import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import React from 'react';
import {
    Box,
    DialogContentText,
    Divider,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import DialogHeader from "./dialogHeader";
import {useNavigate} from "react-router";

const ResultsDialog = (
    {
        open,
        onClose,
        onButton1Click,
        onButton2Click
    }
        :
        {
            open: boolean,
            onClose?: () => void,
            onButton1Click: () => void,
            onButton2Click: () => void
        }
) => {
    const handleButtonClick = (buttonType: string) => {
        if (buttonType === 'button1') {
            onButton1Click();
        } else if (buttonType === 'button2') {
            onButton2Click();
        }
    };
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth fullScreen={isMobile}>

            <DialogHeader title={isMobile ? <Box component="img" margin="auto" display="flex"
                                                 src="https://www.performancegolf.com/wp-content/uploads/2023/11/Vector-1.png"
                                                 alt="logo"/> : "Play & Record Results"}
                          closeAction={onClose}></DialogHeader>
            {isMobile &&
                <Divider light/>
            }
            <DialogContent sx={{'@media (max-width:900px)': {backgroundColor: 'white', borderTop: "1px black"}}}>
                <DialogContentText component="div">
                    <Typography display="block"
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {xs: 25, md: 35},
                                    lineHeight: {xs: "28px", md: "39px"},
                                    color: "#363636",
                                    textAlign: "center",
                                    marginTop: "25px"
                                }}>
                        Your Drill Results Have <br/> Been Submitted!
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: 16,
                            color: "#363636",
                            lineHeight: "19px",
                            textAlign: "center",
                            marginTop: "30px"
                        }}>
                        Results can be found under&nbsp;
                        <Link onClick={() => {
                            document.body.style.touchAction = 'auto';
                            document.body.style.position = 'unset';
                            navigate("/scratch-club/record")
                        }}
                              underline='none'
                              sx={{
                                  cursor: "pointer",
                                  color: "#355ADD",
                                  ':hover': {color: "#355ADD"}
                              }}>Record & Track</Link>,
                        <br/>
                        
                        where you can:
                    </Typography>

                    <Box sx={{display: "flex", margin: "auto"}}>
                        <List sx={{
                            listStyleType: 'disc',
                            alignItems: 'center',
                            margin: "auto",
                            color: "#383838",
                            marginTop: "19px",
                            paddingLeft: {xs: "5px", md: "45px"}
                        }}>
                            <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "19px"}}}>
                                <ListItemText
                                    sx={{margin: 0}}
                                    primaryTypographyProps={{fontSize: 16, fontWeight: 700, lineHeight: "19px"}}>Re-Watch
                                    Drill</ListItemText>
                            </ListItem>
                            <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "19px"}}}>
                                <ListItemText sx={{margin: 0}} primaryTypographyProps={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    lineHeight: "19px"
                                }}>Record
                                    additional
                                    results for that challenge</ListItemText>
                            </ListItem>
                            <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "19px"}}}>
                                <ListItemText sx={{margin: 0}} primaryTypographyProps={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    lineHeight: "19px"
                                }}>View
                                    / Manage
                                    Progress</ListItemText>
                            </ListItem>
                        </List>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: "center",
                    marginBottom: {xs: 0, md: "25px"},
                    alignItems: 'stretch',
                    '@media (max-width:900px)': {flexDirection: 'column'}
                }}>
                <Button variant="outlined"
                        sx={{
                            color: "#18181B",
                            fontSize: 16,
                            fontWeight: 700,
                            lineHeight: "19px",
                            border: "2px solid #18181B",
                            marginRight: 2,
                            marginLeft: 2,
                            padding: "8px 50px",
                            margin: {xs: '0px 10px 30px 10px', md: '0px 16px 16px 10px'},
                            '&:hover': {backgroundColor: "#ffffff", border: "2px solid #444448"},
                            borderRadius: "24px"
                        }}
                        onClick={() => handleButtonClick('button1')}>
                    VIEW RESULTS
                </Button>
                <Button variant="contained"
                        sx={{
                            fontSize: 16,
                            backgroundColor: "#FD3300",
                            color: "#ffffff",
                            fontWeight: 700,
                            lineHeight: "19px",
                            marginRight: 2,
                            padding: "10px 15px",
                            '&:hover': {backgroundColor: "#DB2C00"},
                            margin: {xs: '0px 10px 25px 10px', md: '0px 16px 16px 0'},
                            borderRadius: "24px"
                        }}
                        onClick={() => handleButtonClick('button2')} color="primary">
                    CONTINUE PRACTICING
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ResultsDialog;